import React from 'react';
import './onboard-price-style.scss';
import {useTranslation} from "react-i18next";
import {changePrice} from "../../../util/Currency";

const OnboardPrice = (props) => {
    const {t} = useTranslation();
    const {price, currency, isMil, mil} = props;

    const isInformation = () => {
        return (isMil && parseInt(mil) < parseInt(price));
    }

    return (
        <div className="onboard-price-root">
            <div className="onboard-price-first-row">
                <div className="onboard-price-total">{isMil ? t('payment.total_mil') : t('payment.total_money')}</div>
                <div className="onboard-price-count">{changePrice(price) + " " + currency}
                    {isInformation() && (
                        <span className="onboard-price-count-non">({t('payment.insufficient_miles')})</span>)}
                </div>
            </div>
        </div>
    )
};

export default OnboardPrice;
